"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesFirestore = exports.GameFirestore = void 0;
const players_firestore_1 = require("./players-firestore");
class GameFirestore {
    constructor(root) {
        this.root = root;
        this.players = new players_firestore_1.PlayersFirestore(this.root.collection('users'));
        // construct
    }
}
exports.GameFirestore = GameFirestore;
class GamesFirestore {
    constructor(rawFirestore) {
        this.rawFirestore = rawFirestore;
        // construct
    }
    // games
    game(gameCode) {
        return new GameFirestore(this.rawFirestore.gameDoc(gameCode));
    }
    getGame(gameCode) {
        return this.rawFirestore.getGame(gameCode);
    }
    onGame(gameCode, onNext) {
        return this.rawFirestore.onGame(gameCode, onNext);
    }
    // games - [code]
    // games - [code] - users
    getPlayers(gameCode) {
        return this.rawFirestore.getPlayers(gameCode);
    }
    getPlayer(gameCode, playerEmail) {
        return this.rawFirestore.getPlayer(gameCode, playerEmail);
    }
    mergePlayer(gameCode, playerEmail, data) {
        return this.rawFirestore.mergePlayer(gameCode, playerEmail, data);
    }
    // games - [code] - mods
    onLimitedEducationGameModRound(params) {
        return this.rawFirestore.onLimitedEducationGameModRound(params);
    }
    // games - [code] - reflection-answers
    getReflectionAnswers(gameCode, email) {
        return this.rawFirestore.getReflectionAnswers(gameCode, email);
    }
}
exports.GamesFirestore = GamesFirestore;
